module.exports = __webpack_public_path__ + "static/media/AM.15d174d1.png";